import { P } from 'components/common/P'
import { usePrice } from 'hooks'
import React, { useMemo } from 'react'
import {
  PriceWrapper,
  PriceDetailsWithUnderwriterWrapper,
  UnderwriterImageWrapper,
  PriceInfoWrapper,
  PriceDetailsWrapper,
  PriceBeforeDiscount,
  DiscountedPrice,
  PriceTextLargeBold,
} from './PriceDetails.styles'
import { UnderwriterLogo } from 'components/@Logos/Underwriter'
import { CSSProperties } from 'styled-components'

interface PriceDetailsProps {
  hideDiscount?: boolean
  style?: CSSProperties
}

const PriceDetails = ({ hideDiscount = false, style }: PriceDetailsProps) => {
  const { price, coverTypeWording, totalPriceFixed } = usePrice()

  const affiliateDiscount = price.campaign.Discount

  const positiveDiscountValue = useMemo(
    () => Math.abs(affiliateDiscount),
    [affiliateDiscount],
  )

  const hasAffiliateDiscount = useMemo(
    () => positiveDiscountValue > 0,
    [positiveDiscountValue],
  )

  const discountedTotalPrice = useMemo(
    () => `£${(+totalPriceFixed + positiveDiscountValue).toFixed(2)}`,
    [totalPriceFixed, positiveDiscountValue],
  )

  const coverTypeFullWording = useMemo(() => {
    if (hasAffiliateDiscount) {
      return `${coverTypeWording} - includes £${positiveDiscountValue.toFixed(
        2,
      )} discount`
    }
    return coverTypeWording
  }, [coverTypeWording, hasAffiliateDiscount, positiveDiscountValue])

  if (price.TotalPrice > 0 && price.Underwriter) {
    return (
      <PriceWrapper style={style}>
        <PriceDetailsWithUnderwriterWrapper>
          <UnderwriterImageWrapper>
            <UnderwriterLogo underwriter={price.Underwriter} />
          </UnderwriterImageWrapper>
          <PriceInfoWrapper>
            <PriceDetailsWrapper>
              <P>Total price</P>
              {hasAffiliateDiscount && !hideDiscount && (
                <>
                  <PriceBeforeDiscount>
                    WAS <del>{discountedTotalPrice}</del>
                  </PriceBeforeDiscount>
                  <DiscountedPrice>
                    NOW £
                    <span className='tracking-price'>{totalPriceFixed}</span>
                  </DiscountedPrice>
                </>
              )}
              {(hideDiscount || !hasAffiliateDiscount) && (
                <PriceTextLargeBold>
                  £<span className='tracking-price'>{totalPriceFixed}</span>
                </PriceTextLargeBold>
              )}
              <P>{coverTypeFullWording}</P>
            </PriceDetailsWrapper>
          </PriceInfoWrapper>
        </PriceDetailsWithUnderwriterWrapper>
      </PriceWrapper>
    )
  }
  return null
}

export default PriceDetails
